module.exports = "a.navbar-brand img {\n  max-height: 40px; }\n\ndiv.contact-icon {\n  min-width: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 237
// module chunks = 1